import type {ReactNode} from "react";

import {cn} from "@project/design-system-web";

interface TableActionsColumnHeaderProps {
  children: ReactNode;
  className?: string;
}

/**
 * TableActionsColumnHeader — right-aligns the header content for the actions column.
 *
 * This provides a standard layout for table column headers that contain actions,
 * aligning the header text to the right to match the actions within the rows.
 *
 * @example
 * ```tsx
 * <Table.Column id="actions">
 *   <TableActionsColumnHeader>Actions</TableActionsColumnHeader>
 * </Table.Column>
 * ```
 */
export function TableActionsColumnHeader({children, className}: TableActionsColumnHeaderProps) {
  return <div className={cn("flex w-full items-center justify-end", className)}>{children}</div>;
}
